module.exports = __webpack_public_path__ + "ea05f265d6e205b1fea43087299330a5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-0.png
// module id = 2055
// module chunks = 0